<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-md-1 pt-0 pb-3 pb-lg-2 pb-xl-3 shadow-lg col-12 col-lg-10"
>
  <div
    class="jumbotron-fluid mb-0 mb-lg-5 mb-xl-1 pb-1 pb-lg-3 pb-xl-2 col-12 col-xl-11"
  >
    <div class="container mt-1 mt-md-3 mt-xl-1 mx-0 shadow-lg col-12">
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Station Managers
          </h3>
        </div>
      </div>
    </div>
    <div
      class="invest-card card-body mt-2 py-4 mb-5 mx-0 mx-sm-auto px-1 px-lg-auto shadow-lg"
      [hidden]="loaded"
    >
      <div class="row">
        <div class="col-12">
          <h5 class="rub-head4 text-center font-weight-bold py-1">
            There are no station managers set yet
          </h5>
        </div>
      </div>
    </div>
    <div
      class="invest-card card-body my-2 pt-3 pb-2 px-2 px-lg-3 shadow-lg"
      [hidden]="!loaded"
    >
      <form [formGroup]="managersForm">
        <div class="iteration mb-2" formArrayName="stationManagers">
          <div
            class="item-container my-1"
            *ngFor="
              let items of fval.stationManagers['controls'];
              let idx = index
            "
          >
            <div>
              <div
                class="list-card card mt-1 pt-2 pb-0 py-xl-1 mb-0 mx-0 px-0 shadow-lg"
                [formGroupName]="idx"
              >
                <div class="list-card-body card-body my-0 py-0 mx-0 px-0">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 col-md-5">
                        <div class="row">
                          <div
                            class="col-3 d-flex justify-content-start"
                          >
                            <span class="">Station:</span>
                          </div>
                          <div
                            class="col-9 d-flex justify-content-start font-weight-bold mx-md-0 px-md-0"
                          >
                            <span class="itemCreated">{{
                              fval.stationManagers["controls"][idx]["controls"]
                                .stationName.value
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-10 col-md-5">
                        <div class="row">
                          <div
                            class="col-3 col-md-4 col-xl-3 d-flex justify-content-start"
                          >
                            <span class="">Manager:</span>
                          </div>
                          <div
                            class="col-9 col-md-8 col-xl-9 d-flex justify-content-start font-weight-bold mx-0 px-md-0"
                          >
                            <span class="itemCreated">{{
                              fval.stationManagers["controls"][idx]["controls"]
                                .currentManager.value
                            }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 mx-0 px-0 px-md-4">
                        <button
                          class="edit-button btn-sm btn-infob mx-0 ml-sm-4 ml-xl-5 py-1 px-0"
                          (click)="enableEdit(idx)"
                        >
                          <i
                            class="fas fa-edit"
                            tooltip="Edit"
                            placement="right"
                          ></i>
                        </button>
                        &nbsp;
                        <button
                          class="save-button btn-sm btn-infob ml-4 mr-0 mx-sm-3 py-1 px-0"
                          [disabled]="
                            fval.stationManagers['controls'][idx]['controls'][
                              'selectedManager'
                            ].invalid
                          "
                          (click)="saveManager(idx)"
                        >
                          <i
                            class="fas fa-save"
                            tooltip="Save"
                            placement="right"
                          ></i>
                        </button>
                        <label class="col" *ngIf="errored" class="text-danger">
                          <!-- <i class="material-icons">Cancel</i> -->

                          <ngx-alerts></ngx-alerts>
                        </label>

                        <label class="col" *ngIf="posted" class="text-info">
                          <!-- <i class="material-icons">check_circle</i> -->
                          <ngx-alerts></ngx-alerts>
                        </label>
                      </div>
                    </div>
                    <div class="row mb-2" *ngIf="showLevels == idx">
                      <!--require entry of approval persons per level depending on the number of levels set-->
                      <div class="text-primary col-12">
                        <label
                          for=""
                          class="mx-1"
                          [ngClass]="
                            fval.stationManagers['controls'][idx]['controls'][
                              'selectedManager'
                            ].valid
                              ? 'text-info'
                              : ''
                          "
                        >
                          Select a manager from available station users
                        </label>
                        <select
                          formControlName="selectedManager"
                          class="form-control col-md-6 col-lg-5 col-xl-4"
                          [ngClass]="{
                            'is-invalid':
                              (fval.stationManagers['controls'][idx][
                                'controls'
                              ]['selectedManager'].touched ||
                                fval.stationManagers['controls'][idx][
                                  'controls'
                                ]['selectedManager'].dirty) &&
                              fval.stationManagers['controls'][idx]['controls'][
                                'selectedManager'
                              ].errors
                          }"
                          autocomplete="off"
                          placeholder="Select required managers"
                        >
                          <option></option>
                          <option *ngFor="let user of users">
                            {{ user.userName.toUpperCase() }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
